"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabContext = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _lib = require("../../lib");

var _Menu = _interopRequireDefault(require("./Menu"));

var _Content = _interopRequireDefault(require("./Content"));

require("./styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TabContext = (0, _react.createContext)({
  data: [],
  content: null,
  value: undefined,
  onChange: function onChange() {},
  goNext: function goNext() {},
  goBack: function goBack() {},
  isFirst: false,
  isLast: false
});
exports.TabContext = TabContext;

var TabProvider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TabProvider, _PureComponent);

  function TabProvider(props) {
    var _this;

    _classCallCheck(this, TabProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TabProvider).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getCurrentIndex", function () {
      return _this.state.data.findIndex(function (d) {
        return d.value === _this.state.value;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getCurrentContent", function () {
      var disabled = _this.props.disabled;
      var _this$state = _this.state,
          data = _this$state.data,
          value = _this$state.value;

      if ((0, _lib.arrayHasItems)(data)) {
        var currentTab = data.find(function (d) {
          return d.value === value;
        });

        if (currentTab) {
          return (0, _lib.getRenderProps)(currentTab.content, {
            data: data,
            value: value,
            currentTab: currentTab,
            disabled: disabled,
            active: value && value === currentTab.value,
            onChange: _this.handleOnChange
          });
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "isCurrentTabFirst", function () {
      var currentIndex = _this.getCurrentIndex();

      return currentIndex === 0;
    });

    _defineProperty(_assertThisInitialized(_this), "isCurrentTabLast", function () {
      var currentIndex = _this.getCurrentIndex();

      return currentIndex === _this.state.data.length - 1;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, value) {
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      _this.setState({
        value: value
      }, function () {
        var _this$props = _this.props,
            name = _this$props.name,
            onChange = _this$props.onChange;

        if (onChange) {
          onChange(e, {
            name: name,
            value: value
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleGoPrevious", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var data = _this.state.data;

      var currentIndex = _this.getCurrentIndex();

      if (currentIndex > 0) {
        _this.handleOnChange(e, data[currentIndex - 1].value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleGoNext", function (e) {
      (0, _lib.callEventMethods)(e, 'persist');

      if (_this.props.disabled) {
        (0, _lib.callEventMethods)(e, 'preventDefault');
        return;
      }

      var data = _this.state.data;

      var currentIndex = _this.getCurrentIndex();

      if (currentIndex < data.length - 1) {
        _this.handleOnChange(e, data[currentIndex + 1].value);
      }
    });

    var _value = props.value,
        defaultValue = props.defaultValue,
        _data = props.data;
    _this.state = {
      prevProps: {
        value: _value,
        data: _data
      },
      // this only store props.value
      value: _value || defaultValue || ((0, _lib.arrayHasItems)(_data) ? _data[0].value : undefined),
      data: _data
    };
    return _this;
  }

  _createClass(TabProvider, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      var data = this.state.data;
      var value = {
        value: this.state.value,
        data: data,
        content: this.getCurrentContent(),
        onChange: this.handleOnChange,
        goNext: this.handleGoNext,
        goPrevious: this.handleGoPrevious,
        isFirst: this.isCurrentTabFirst(),
        isLast: this.isCurrentTabLast()
      };
      return _react.default.createElement(TabContext.Provider, {
        value: value
      }, children);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          data = props.data;
      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          data: data
        },
        value: prevProps.value !== value ? value : state.value,
        data: prevProps.data !== data ? data : state.data
      };
    }
  }]);

  return TabProvider;
}(_react.PureComponent);

exports.default = TabProvider;

_defineProperty(TabProvider, "Consumer", TabContext.Consumer);

_defineProperty(TabProvider, "Menu", _Menu.default);

_defineProperty(TabProvider, "Content", _Content.default);

_defineProperty(TabProvider, "displayName", 'TabProvider');

_defineProperty(TabProvider, "propTypes", {
  children: _propTypes.default.node.isRequired,
  disabled: _propTypes.default.bool,
  name: _propTypes.default.string,
  value: _common.customPropTypes.stringOrNumber,
  defaultValue: _common.customPropTypes.stringOrNumber,
  onChange: _propTypes.default.func,
  data: _propTypes.default.arrayOf(_propTypes.default.shape({
    menu: _common.customPropTypes.render,
    value: _common.customPropTypes.stringOrNumber,
    content: _common.customPropTypes.render
  }))
});

_defineProperty(TabProvider, "defaultProps", {
  disabled: false,
  name: null,
  value: undefined,
  defaultValue: undefined,
  onChange: null,
  data: []
});